export const transitionTotalTime = 2.5;